import React from 'react';

import { RouteProps } from '../utils/Types';

const PublicRoute = (props: RouteProps) =>
  !props.isLoggedIn() ? <React.Fragment>{props.children}</React.Fragment> : null;

export default PublicRoute;
